export const TennistalkerIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='69px'
    height='40px'
    viewBox='0 0 68 40'
    fill='none'
    style={{ color: 'currentColor' }}
  >
    <g id='surface1'>
      <path
        d='M 63.789062 0.0234375 L 61.058594 10.917969 C 61.058594 10.917969 53.875 11.039062 43.382812 13.289062 L 46.703125 0.0234375 Z M 63.789062 0.0234375 '
        fill='currentColor'
      />
      <path
        d='M 42.660156 0.0234375 L 39.316406 13.363281 L 28.011719 13.363281 L 26.832031 18.0625 C 20.554688 20.367188 13.917969 23.417969 7.382812 27.453125 L 10.914062 13.359375 L 0 13.359375 L 3.339844 0.0234375 Z M 42.660156 0.0234375 '
        fill='currentColor'
      />
      <path
        d='M 68 26.636719 L 64.660156 39.976562 L 25.242188 39.976562 L 28.585938 26.636719 L 40.035156 26.636719 L 42.21875 17.929688 C 52.855469 14.332031 60.414062 13.460938 60.414062 13.460938 L 57.121094 26.636719 Z M 68 26.636719 '
        fill='currentColor'
      />
      <path
        d='M 25.007812 25.339844 L 21.339844 39.976562 L 4.242188 39.976562 C 10.929688 33.792969 18.101562 29.015625 25.003906 25.339844 Z M 25.007812 25.339844 '
        fill='currentColor'
      />
    </g>
  </svg>
)
